#!/usr/bin/env node

import { Command } from 'commander'
import { patch } from './commands/patch'
import { version } from '../index'

const program = new Command()

program
  .name('tailwindcss-taro')
  .description('超越 weapp-tailwindcss 的 TailwindCSS Taro CLI 工具')
  .version(version)

// patch 命令
program
  .command('patch')
  .description('自动 patch 小程序构建工具或 Taro 构建产物')
  .option('-p, --platform <platform>', '目标平台 (weapp|h5)', 'weapp')
  .option('-d, --dist <path>', '构建产物目录', 'dist')
  .option('-v, --verbose', '详细日志')
  .option('--runtime', '启用运行时调试支持')
  .option('--class-patch', '修复类名被去除的问题')
  .option('--selector-patch', '修复选择器兼容性问题')
  .action(async (options: any) => {
    try {
      await patch(options)
    } catch (error) {
      console.error('❌ Patch 失败:', error)
      process.exit(1)
    }
  })

// 其他命令可以在这里添加
program
  .command('analyze')
  .description('分析构建产物')
  .option('-d, --dist <path>', '构建产物目录', 'dist')
  .action(async (options: any) => {
    // TODO: 实现分析功能
    console.log('🔍 分析功能开发中...')
  })

program.parse() 